import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const createPayoutApi = (data, callback, errorCallBack) => {

    return async (dispatch) => {

        formDataCommonFunction(data, apiConstants.PAYMENT_GATEWAY.CREATE_PAYOUT)
            .then((response) => {
                callback && callback(response)

            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}